import Level from "../components/Level";
import axios from "axios";
import { useState, useEffect } from "react";
import params from "../params";
import ModalWindow from "../components/LevelPopup";
import Dim from "../components/Dim";
import rand from "../utils/random";

export default function Challengelist() {
    const [levels, setLevels] = useState([]);

    useEffect(() => {
        const req = async () => {
            try {
                let url = '';
                if(!params.server) url = './demonlist/challenges.txt?' + rand.getRandomInt(111, 999);
                else url =  params.apiUrl + '/demonlist/getDL.php';
                const r = await axios.get(url);
                const lines = r.data.split('\n');
                const lvls = [];

                for(let i = 0; i < lines.length; i++) {
                    if(!lines[i]) continue;

                    const params = lines[i].split(';');
                    lvls.push({ name: params[0], author: params[1], id: params[2], verification: params[3], points: params[4] });
                }

                setLevels(lvls);
            } catch(e) {
                throw new Error(e.message);
            }
        }

        req();
    }, []);

    const handleLevelClick = (item) => ModalWindow.getWindow(item);
    
    return (
        <main>
            <ModalWindow />
            <Dim window={ModalWindow} />
            <div className="container">
                <ul className="dl-list">
                    {
                        levels.map((e, index) => {
                            return <Level index={index + 1} key={index} name={e.name} author={e.author} id={e.id} verification={e.verification} points={e.points} item={e} onClick={handleLevelClick} />
                        })
                    }
                </ul>
            </div>
        </main>
    );
}